// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-with-loading {
  position: relative;
  padding: 0 23px;
}
.button-with-loading__loading-wrapper {
  position: absolute;
  top: 50%;
  left: 5px;
  transform: translateY(-50%);
  color: var(--color-white);
}
.button-with-loading__indicator {
  height: 13px;
  width: 13px;
}
.button-with-loading--loading.button-with-loading,
.button-with-loading--loading.button-with-loading.disabled {
  background-color: var(--color-accent-background-base);
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/components/button-with-loading/ButtonWithLoading.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,eAAA;AACF;AACE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,yBAAA;AACJ;AAEE;EACE,YAAA;EACA,WAAA;AAAJ;AAII;;EAEE,qDAAA;AAFN","sourcesContent":[".button-with-loading {\n  position: relative;\n  padding: 0 23px;\n\n  &__loading-wrapper {\n    position: absolute;\n    top: 50%;\n    left: 5px;\n    transform: translateY(-50%);\n    color: var(--color-white);\n  }\n\n  &__indicator {\n    height: 13px;\n    width: 13px;\n  }\n\n  &--loading {\n    &.button-with-loading,\n    &.button-with-loading.disabled {\n      background-color: var(--color-accent-background-base);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
